<his-plam>
    <p-autoComplete #processingStepDropdown #content hisDdKey="rm.erp.common.workflow.ProcessingStep" [dropdown]="true"
        field="text" [(ngModel)]="selectedProcessingStep" [suggestions]="filteredProcessingStepValues"
        [forceSelection]="true" (completeMethod)="filterProcessingStepValues()"
        (onSelect)="onSelectProcessingStep($event)">
    </p-autoComplete>
</his-plam>

<his-plam>
    <p-autoComplete #nextResponsiblePersonDropdown #content hisDdKey="rm.erp.common.workflow.NextResponsiblePerson"
        [dropdown]="true" [(ngModel)]="selectedNextResponsiblePerson"
        [field]="$any(convertNextResponsiblePersonDisplay)" [suggestions]="filteredNextResponsiblePersonValues"
        (completeMethod)="onCompleteNextResponsiblePersonValues()" (onSelect)="onSelectNextResponsiblePerson($event)" (onKeyUp)="filterNextResponsiblePersonValuesAfterInput($event)">
    </p-autoComplete>
</his-plam>

<his-plam>
    <textarea #content hisDdKey="rm.erp.common.workflow.StepExecutionComment" [(ngModel)]="stepExecutionComment" class="textareaWidth100" rows="1">
	</textarea>
</his-plam>
